import { render, staticRenderFns } from "./controlsReflection.vue?vue&type=template&id=6a9f7dbb&"
import script from "./controlsReflection.vue?vue&type=script&lang=js&"
export * from "./controlsReflection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9f7dbb')) {
      api.createRecord('6a9f7dbb', component.options)
    } else {
      api.reload('6a9f7dbb', component.options)
    }
    module.hot.accept("./controlsReflection.vue?vue&type=template&id=6a9f7dbb&", function () {
      api.rerender('6a9f7dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reflection/controlsReflection.vue"
export default component.exports